// src/app/translate.initializer.ts
import { TranslateService } from '@ngx-translate/core';

export function translateInitializer(
  translate: TranslateService
) {
  return () => {
    const lang =
      localStorage.getItem('lang') ||
      navigator.language ||
      'en';

    translate.setDefaultLang(lang);
    return translate.use(lang).toPromise();
  };
}
